import { defineStore } from "pinia";
import Network from "~/utils/network";

const urls = {
  autoloadConfigs: "/api/administration/ui-configs/portal",
  configWithIdentifier: (identifier) =>
    `/api/administration/ui-config/portal/${identifier}`,
};

export const useConfigStore = defineStore("config", {
  state: () => ({
    autoloadConfigs: [],
    configs: {},
  }),
  getters: {
    getAutoloadConfigValue: (state) => (identifier) => {
      const configsByIdentifier = state.autoloadConfigs.filter(
        (config) => config.identifier === identifier
      );
      if (configsByIdentifier.length === 1) {
        return configsByIdentifier[0].value;
      }
      return null;
    },
  },
  actions: {
    fetchAutoloadConfigs: async function () {
      try {
        this.autoloadConfigs = await Network.http(urls.autoloadConfigs);
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    fetchConfig: async function (identifier) {
      try {
        this.configs[identifier] = await Network.http(
          urls.configWithIdentifier(identifier)
        );
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
  },
});
